import { APIClient } from "../helpers/api_helper";
import {
  ApiResponse,
  PaginatedApiResponse,
  PaginationParams,
} from "../types/api";
import {
  BookServiceBundlePayload,
  BookServiceBundleResponse,
  CreateServiceBundlePayload,
  ServiceBundle,
  ServiceBundleAvailabilitySlot,
  UpdateServiceBundlePayload,
} from "../types/serviceBundle";

const api = new APIClient();

const RESOURCE = "/service-bundles";

export type {
  ServiceBundle,
  CreateServiceBundlePayload,
  UpdateServiceBundlePayload,
  ServiceBundleItem,
  ServiceBundleItemPayload,
} from "../types/serviceBundle";

export interface ServiceBundleListParams extends PaginationParams {
  unit_id?: number;
  search?: string;
  is_active?: boolean;
}

export const getServiceBundles = (
  params?: ServiceBundleListParams
): Promise<PaginatedApiResponse<ServiceBundle>> =>
  api.get<PaginatedApiResponse<ServiceBundle>>(RESOURCE, params);

export const getServiceBundle = (id: number): Promise<ApiResponse<ServiceBundle>> =>
  api.get<ApiResponse<ServiceBundle>>(`${RESOURCE}/${id}`);

export const createServiceBundle = (
  payload: CreateServiceBundlePayload
): Promise<ApiResponse<ServiceBundle>> =>
  api.create<ApiResponse<ServiceBundle>>(RESOURCE, payload);

export const updateServiceBundle = (
  id: number,
  payload: UpdateServiceBundlePayload
): Promise<ApiResponse<ServiceBundle>> =>
  api.update<ApiResponse<ServiceBundle>>(`${RESOURCE}/${id}`, payload);

export const deleteServiceBundle = (
  id: number
): Promise<ApiResponse<Record<string, never>>> =>
  api.delete<ApiResponse<Record<string, never>>>(`${RESOURCE}/${id}`);

export const toggleServiceBundleStatus = (
  id: number
): Promise<ApiResponse<ServiceBundle>> =>
  api.update<ApiResponse<ServiceBundle>>(`${RESOURCE}/${id}/toggle-status`, {});

export interface BundleAvailabilityParams {
  date: string;
  unit_id: number;
  items?: Array<{
    sort_order: number;
    professional_id?: number | null;
  }>;
}

export const getBundleAvailability = (
  bundleId: number,
  params: BundleAvailabilityParams
): Promise<ApiResponse<ServiceBundleAvailabilitySlot[]>> =>
  api.get<ApiResponse<ServiceBundleAvailabilitySlot[]>>(
    `${RESOURCE}/${bundleId}/availability`,
    params
  );

export const bookServiceBundle = (
  bundleId: number,
  payload: BookServiceBundlePayload
): Promise<ApiResponse<BookServiceBundleResponse>> =>
  api.create<ApiResponse<BookServiceBundleResponse>>(`${RESOURCE}/${bundleId}/book`, payload);
